import { QRCode } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SQRCode = styled(QRCode)``;
